import { camelize } from 'helpers/syntaxHelper';
import { BudgetProposalT } from '../config/types';

/**
 * Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Deals specifically with budget_proposals fetch body, by camelizing by values
 * into payload.data budgetProposals objects.
 */
export const budgetProposalsPostProcessingMiddleware = (body: {
    data: { by: string }[];
}) => {
    const postProcessedData = body.data.map(
        (budgetProposal: BudgetProposalT) => ({
            ...budgetProposal,
            by: camelize(budgetProposal.by),
            projectionBy: budgetProposal.projectionBy.map(camelize),
            pluriannualProjectionBy:
                budgetProposal.pluriannualProjectionBy.map(camelize),
        }),
    );
    return {
        ...body,
        data: postProcessedData,
    };
};
